import React from 'react'
import * as UI from 'ui/index'
import { CardHeader, SecondaryHeading } from 'ui/index'
import { Collection, ForEachModel, ValueToCollection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import PermissionGroupCategoryTitle from 'pages/app/settings/permissions/partials/PermissionGroupCategoryTitle'
import * as Displays from 'support/displays'

export default function ForEachPermission ({ children }) {
  return (
    <UI.CardGroup>
      <Collection resourceName='permissions.groups'>
        <WhenCollectionIsNotEmpty>
          <ForEachModel>
            <UI.Card>
              <CardHeader>
                <SecondaryHeading>
                  <Displays.Text name='key'/>
                </SecondaryHeading>
              </CardHeader>
              <ValueToCollection name='collection'>
                <UI.VerticalList>
                  <ForEachModel>
                    {children}
                  </ForEachModel>
                </UI.VerticalList>
              </ValueToCollection>
            </UI.Card>
          </ForEachModel>
        </WhenCollectionIsNotEmpty>
      </Collection>
    </UI.CardGroup>
  )
}
